import { render, staticRenderFns } from "./VehicleMake.vue?vue&type=template&id=94cc4efe&"
import script from "./VehicleMake.vue?vue&type=script&lang=js&"
export * from "./VehicleMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports